"use strict";

import React from 'react';
import AccountSettingSecurityCard from "./AccountSettingSecurityCard";
import AccountSettingBillingCard from "./AccountSettingBillingCard";

const AccountSettings = ({account={}, address={},}) => {
    return (
        <React.Fragment>
            <h3>Settings</h3>
            <div className=" columns echeck__settings__list">
                <div className="column is-half-desktop echeck__settings__list-item">
                    <AccountSettingBillingCard address={address} />
                </div>
                <div className="column is-half-desktop echeck__settings__list-item">
                    <AccountSettingSecurityCard email={account?.user?.email} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default AccountSettings;
